module.exports = __webpack_public_path__ + "img/ameer-taweel.710c72c4.jpg";